module.exports = __webpack_public_path__ + "img/common-popup.f042825c.png";